{
  "appName": "22-10282 IBM Skillsbuild Training Program Intake Application",
  "entryFile": "./app-entry.jsx",
  "entryName": "10282-edu-benefits",
  "rootUrl": "/education/other-va-education-benefits/ibm-skillsbuild-program/apply-form-22-10282",
  "productId": "08807bf4-46b3-4236-9e43-88d3dd7c8325"
}
